import React from "react";
import Notification from "../../../shared/items/static/notification";

const ReportNoDataInfo = (props) => {
  const { info } = props;
  return (
    <Notification type="warning" styles={{ heigth: "40px" }}>
      <p>{`Данные по ТС ${info.title} c регистационным номером ${info.registerNumber} отсуствуют `}</p>
    </Notification>
  );
};

export default React.memo(ReportNoDataInfo);
